import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import styles from './AppModal.module.scss'
import { AppModalHeader } from './AppModalHeader'

interface Props {
  onClose?(): void
  title?: string
  className?: string
  childrenClassName?: string
  children?: React.ReactNode
}
export const AppModal = ({
  title,
  className,
  childrenClassName,
  children,
  onClose,
}: Props) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setMounted(false)
        document.body.style.overflow = 'unset'
        onClose?.()
      }
    }

    document.addEventListener('keydown', handleEscape)
    document.body.style.overflow = 'hidden'
    setMounted(true)

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [])

  const element = (
    <div role="dialog" className={styles.container}>
      <div onClick={onClose} className={styles.overlay} />
      <div className={classNames(styles.content, className)}>
        <AppModalHeader title={title} onClose={onClose} />

        <div className={classNames(styles.children, childrenClassName)}>
          {children}
        </div>
      </div>
    </div>
  )

  return <>{mounted ? createPortal(element, document.body) : null}</>
}
